import http from "../http/http-config";
import { TheftQuotationResponse } from "../models/theftQuotationResponse";

export default new class TheftQuotationService {
    // Movilidad Urbana 
    async createTheft936Quotation(model: string): Promise<TheftQuotationResponse> {        
        const response = await http.post<TheftQuotationResponse>("TheftQuotation", model);
        if (response.status === 204) {
            throw new Error(response.status.toString());
        }
        return response.data;
    }

    // Equipo Electronico
    async createTheft1000Quotation(model: string): Promise<TheftQuotationResponse> {
        const response = await http.post<TheftQuotationResponse>("TheftQuotation/GetTheft1000Quotation", model);
        if (response.status === 204) {
            throw new Error(response.status.toString());
        }
        return response.data;
    }
}